// extracted by mini-css-extract-plugin
export default {"container":"RobotThumbnail_container__d61Wv","initial":"RobotThumbnail_initial__JoM+Q"};